export const getSelectedProductsAmount = (products: Record<string, any>) =>
  Object.values(products).reduce((acc, curr) => {
    if (curr && curr.selectedAmount >= 1) {
      acc[curr.id] = curr.selectedAmount;
    }
    return acc;
  }, {});
